import {
  SET_LOADING,
  GET_TRACKING,
  GET_TRACKING_ERROR,
  FULFILL_ORDER,
  FULFILL_ORDER_PROGRESS,
} from "../types";

const TrackingReducer = (state, action) => {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        loading: true,
      };

    case GET_TRACKING:
      return {
        ...state,
        tracking: action.payload,
        loading: false,
      };

    case FULFILL_ORDER:
      return {
        ...state,
        returnedData: action.payload,
        loading: false,
      };

    case FULFILL_ORDER_PROGRESS:
      return {
        ...state,
        fulfillProgress: action.payload,
      };

    case GET_TRACKING_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default TrackingReducer;